import Vue from 'vue'
import ElementUI from 'element-ui'
import "babel-polyfill"
import store from './store/index';
import 'element-ui/lib/theme-chalk/index.css'
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import App from './App.vue'
import Router from './router'
import filters from "~/filters";
import CmsColumn from "~/components/cms/CmsColumn.vue";
import CmsColumnList from "~/components/cms/CmsColumnList.vue";
import CmsColumnJson from "./components/cms/CmsColumnJson.vue";
import CmsArticleList from "~/components/cms/CmsArticleList.vue";
import SystemColumnId from "~/enum/SystemColumnId";
import CmsImage from "~/components/cms/CmsImage.vue";
import Page from './components/Page'
import ZuiHeader from './components/Header'
import ZuiFooter from './components/Footer'
import EnglishHeader from './components/english_header'
import EnglishFooter from './components/english_footer'
import PageNavigater from "~/components/PageNavigater.vue";
import EnPageNavigater from "~/components/entemplate/en_PageNavigater.vue";
import hoveranimate from "~/directive/hoveranimate";
import 'animate.css';
import './components/less/reset.less'
import './assets/css/common.css'
import './assets/css/animation.css'

import {setRemInit} from './rem';


setRemInit(); //进行初始化立即运行

function openNewWindow(url){
    let jumpUrl = url.path ? url.path : url
    window.open(jumpUrl, '_blank');
}

Vue.use(ElementUI)
Vue.use(VueViewer)

Vue.component("CmsColumn", CmsColumn)
Vue.component('CmsColumnList', CmsColumnList)
Vue.component('CmsColumnJson', CmsColumnJson)
Vue.component('CmsArticleList', CmsArticleList)
Vue.component("CmsImage", CmsImage)
Vue.component("Page", Page)
Vue.component("ZuiHeader", ZuiHeader)
Vue.component("ZuiFooter", ZuiFooter)
Vue.component("EnglishHeader", EnglishHeader)
Vue.component("EnglishFooter", EnglishFooter)
Vue.component("PageNavigater", PageNavigater)
Vue.component("EnPageNavigater", EnPageNavigater)
Vue.prototype.$cid = SystemColumnId
Vue.prototype.$store = store
Vue.prototype.$openNewWindow = openNewWindow

// 自定义指令全局注册
Vue.directive('hoveranimate', hoveranimate);

// 过滤器
Object.keys(filters).forEach(item => {
    Vue.filter(item, filters[item])
})

new Vue({
    //Vue 使用配置好的路由
    router: Router,
    store,
    el: '#app',
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js